import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { Grid, Col } from '@koaly/grid';
import { spacing, getSizeToken, getVariantToken, spaceProp } from '@koaly/mixins';
import React from 'react';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';

const StyledFooter = styled.footer `
  padding-top: ${spacing(24)};
  padding-bottom: ${spacing(24)};
`;
const StyledFooterItemBorder = styled.div `
  border-bottom: ${getSizeToken('footer', 'itemBorderSize')} solid ${getVariantToken('footer', 'itemBorderColor')};

  ${up('s')} {
    border-radius:  ${getSizeToken('footer', 'itemBorderRadius')};
    border: ${getSizeToken('footer', 'itemBorderSize')} solid ${getVariantToken('footer', 'itemBorderColor')};
  }

  ${({ spacing }) => spaceProp(spacing, 'padding')};
`;
const FooterContainer = (_a) => {
    var { children, className } = _a, gridProps = __rest(_a, ["children", "className"]);
    return (React.createElement(StyledFooter, { className: className, as: "footer" },
        React.createElement(Grid, Object.assign({}, gridProps), children)));
};
FooterContainer.defaultProps = {
    gutter: { xs: 10, m: 20 },
    gutterRows: { xs: 10, m: 0 },
};
const FooterItemBorder = (_a) => {
    var { children, spacing } = _a, colProps = __rest(_a, ["children", "spacing"]);
    return (React.createElement(Col, Object.assign({}, colProps),
        React.createElement(StyledFooterItemBorder, { spacing: spacing }, children)));
};
FooterItemBorder.defaultProps = {
    spacing: 10,
};
const FooterItem = (_a) => {
    var { children } = _a, colProps = __rest(_a, ["children"]);
    return (React.createElement(Col, Object.assign({}, colProps), children));
};

export { FooterContainer, FooterItem, FooterItemBorder };
//# sourceMappingURL=Footer.js.map
